/** Internal dependencies */
import { prepareApiCall } from "./prepareApiCall";

export function handleResetButton(e) {
  const target = e.target.closest("button");
  if (!target) {
    return;
  }

  e.preventDefault();

  const parent = target.closest("[data-rest]");
  const activeFilters = parent.querySelectorAll(
    '[data-filter="button"].active, [data-filter="dropdown"]:checked'
  );

  if (activeFilters) {
    activeFilters.forEach((filter) => {
      switch (filter.dataset.filter) {
        case "button":
          filter.setAttribute("aria-pressed", "false");
          filter.classList.remove("active");
          break;
        case "dropdown":
          filter.checked = false;
          break;
      }
    });

    const activeFiltersContainer = parent.querySelector(
      "[data-filters-active]"
    );
    if (activeFiltersContainer) {
      activeFiltersContainer.textContent = "";
    }

    prepareApiCall(parent);
  }
}
